export const GAME_OVERVIEW = "GAME_OVERVIEW";
export const gameOverview = data => ({
    type: GAME_OVERVIEW,
    payload: data
});
